import axios from 'axios'
import endpoints from '../../endpoints'
import {TeamLeaderBase} from './type'
import {APIResponse, NFCBase, NFCCreate} from '../../../types/type'

const API_URL = process.env.REACT_APP_API_URL || ''

export async function fetchTeamLeaderList(): Promise<APIResponse<TeamLeaderBase[]>> {
  const response = await axios.get(API_URL + endpoints.teamLeader.list)
  return response.data
}

export async function createTeamLeader(
  body: Omit<TeamLeaderBase, 'teamleader_id'>
): Promise<APIResponse<null>> {
  const response = await axios.post(API_URL + endpoints.teamLeader.create, body)
  return response.data
}

export async function updateTeamLeader(body: TeamLeaderBase): Promise<APIResponse<null>> {
  const response = await axios.post(API_URL + endpoints.teamLeader.update, body)
  return response.data
}

export async function deleteTeamLeader(teamLeaderId: string | number): Promise<APIResponse<null>> {
  const response = await axios.get(API_URL + endpoints.teamLeader.delete + teamLeaderId)
  return response.data
}
export async function addNFCtoTeamLeader(payload: NFCCreate) {
  try {
    const response = await axios.put(API_URL + endpoints.nfc.createUserNFC, payload)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function getTeamLeaderNFC(id: number): Promise<APIResponse<NFCBase>> {
  try {
    const response = await axios.put(API_URL + endpoints.nfc.getUserNFC, {
      id,
      type: 'team_leader',
    })
    return response.data
  } catch (error) {
    throw error
  }
}
